export default function Spinner({ marginTop, marginBottom, size = 'medium' }) {
    return (
        <div
            className={`spinner${marginTop ? ' margin-top' : ''}${
                marginBottom ? ' margin-bottom' : ''
            } size-${size}`}
        ></div>
    )
}
